import { Component, Input, ElementRef } from '@angular/core';
import { RemittanceDocument } from '@feature/payments-to-you/models/remittance-document';
import { PrintService } from '@feature/_app_modules/printing/services/print.service';
import { styleCss } from '@feature/payments-to-you/constants/remittance-document-style';

@Component({
  selector: 'remittance-document-print-layout',
  templateUrl: './remittance-document-print-layout.component.html',
  styleUrls: ['./remittance-document-print-layout.component.scss']
})
export class RemittanceDocumentPrintLayoutComponent {

  @Input() remittanceDocument:RemittanceDocument;
  remittanceTotal: number;  

  constructor(private readonly printService: PrintService, private ref: ElementRef) {
  }

  ngOnChanges() {
    if (this.remittanceDocument) {
      this.remittanceTotal = this.remittanceDocument.DetailItems.reduce((sum, current) => sum + current.Amount, 0);
    }

  }

  paymentReferenceText(paidBy: string): string {
    if (paidBy == 'Cheque') {
      return 'Cheque No:';
    }
    return 'Payment Ref:';
  }

  ngAfterViewChecked() {
    if (this.remittanceDocument) {
      this.printService.print(this.ref, true, [ styleCss ]);
      this.remittanceDocument = undefined;
    }
  }

}
